import { BuildBeneficiaries } from 'app/src/features/Shopping/shared/utils'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { Image } from 'app/src/shared/components'
import { euroFormatterIt, formatDateDDMMYYYY } from 'app/src/shared/helpers'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function GoodAndServiceWidget(props: { order: shoppingApi.OrderDetails }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  const orderDetailsPurchaseGoodAndService = props.order?.purchaseDetails as shoppingApi.OrderDetailsPurchaseGoodAndService
  const amount = useMemo(() => {
    let importo = t('Common.freeAmount')

    if (props.order.priceDetails?.grossPrice && props.order.priceDetails.grossPrice > 0)
      importo = euroFormatterIt.format(props.order.priceDetails.grossPrice)
    return importo
  }, [t, props.order])

  const beneficiaries = useMemo(() => BuildBeneficiaries(props.order), [props.order])

  return (
    orderDetailsPurchaseGoodAndService && (
      <div className='printable card grid grid-cols-1 divide-x-0 divide-y-2 divide-dotted rounded-xl border border-solid border-[var(--primary-color)] bg-[var(--primary-color)] p-5 text-white lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
        <div className='lg:min-w[300px] col-span-12 p-2 text-center lg:col-span-4 lg:pr-5'>
          <div className='mb-4' dangerouslySetInnerHTML={{ __html: t('Common.pwsLogo') }} />
          <>
            {orderDetailsPurchaseGoodAndService?.voucherImageUrl && (
              <div className='mx-auto mb-4 max-h-fit max-w-fit rounded-xl border bg-white p-[2px]'>
                <Image
                  alt="Immagine del voucher per l'utilizzo del bene o servizio"
                  pt={{ image: { className: 'max-w-[220px] max-h-[220px]' } }}
                  src={orderDetailsPurchaseGoodAndService?.voucherImageUrl}
                />
              </div>
            )}
            {orderDetailsPurchaseGoodAndService?.voucherCode && (
              <>
                <div
                  className='mb-1'
                  dangerouslySetInnerHTML={{
                    __html: t('GoodAndService.voucherCodeDescription'),
                  }}
                />
                <div className='text-base font-bold'>
                  <span>{orderDetailsPurchaseGoodAndService.voucherCode}</span>
                </div>
              </>
            )}
          </>
        </div>
        <div className='lg:min-w[500px] col-span-12 mx-auto w-full p-2 lg:col-span-8 lg:pl-5'>
          <div className='mt-6 lg:mt-0'>{t('GoodAndService.orderIdLabel')}</div>
          <div className='mb-4 w-full break-words pt-2 font-bold uppercase lg:mb-0'>{props.order?.orderId ?? '-'}</div>
          <div className='mb-4 mt-2 hidden h-px w-full bg-white lg:block'></div>
          <div className='grid grid-cols-12'>
            <div className='col-span-12 mb-4 mt-2 lg:col-span-4 lg:my-0'>
              <div>{t('GoodAndService.productDescription')}</div>
              <div className='pt-2 font-bold uppercase'>{props.order.product?.productName}</div>
            </div>
            <div className='col-span-12 mt-2 lg:col-span-4 lg:col-start-7 lg:mt-0'>
              <div>{t('GoodAndService.priceDescription')}</div>
              <div className='pt-2 font-bold uppercase'>{amount}</div>
            </div>
          </div>
          <div className='mt-4 grid grid-cols-12'>
            <div className='col-span-12 mb-4 mt-2 lg:col-span-4 lg:my-0'>
              <div>{t('GoodAndService.buyerDescription')}</div>
              <div className='pt-2 font-bold uppercase'>{beneficiaries}</div>
            </div>
            <div className='col-span-12 mt-2 lg:col-span-4 lg:col-start-7 lg:mt-0'>
              <div>{t('GoodAndService.buyDateDescription')}</div>
              <div className='pt-2 font-bold uppercase'>
                {orderDetailsPurchaseGoodAndService?.purchaseDate
                  ? formatDateDDMMYYYY(new Date(orderDetailsPurchaseGoodAndService?.purchaseDate), true)
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}
